import { ThunderDispatcher } from './thunder-dispatcher.js';
export const dispatch_onPageTitleChanged = new ThunderDispatcher('__onPageTitleChanged');
//# sourceMappingURL=consts.js.map